import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { fetchCompany } from "@/lib/api";

const CompanyContext = createContext({ company: null, refresh: () => {} });

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(null);

  const refresh = useCallback(() => {
    fetchCompany().then(setCompany).catch(() => setCompany({}));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ company, refresh }), [company, refresh]);

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  return useContext(CompanyContext);
}
